import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { IMasterNamePerson, INarrative, INarrativeRequest } from '@/models';
import { IWantedPerson } from '@/models/wanted.person';

import { http } from './http';
import {
  IGetParams,
  IIndeterminatePaginationResponse,
  IPaginatedListResponse,
} from './types';

export interface IFilterPersonsParams {
  filter?: string;
  sort?: string;
  page?: number;
  limit?: number;
}

export const WantedPersonApi = {
  getWantedPersonList: (
    params?: IGetParams,
  ): Promise<
    AxiosResponse<IIndeterminatePaginationResponse<IWantedPerson>>
  > => {
    return http.get(`api/${ApiVersion.V1}/wanted-persons`, {
      params,
    });
  },
  filterPersons: (
    params: IFilterPersonsParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IMasterNamePerson>>> => {
    return http.get(`api/${ApiVersion.V1}/wanted-persons/filter-persons`, {
      params,
    });
  },
  createWantedPerson: (
    wantedPerson: IWantedPerson,
  ): Promise<AxiosResponse<IWantedPerson>> => {
    return http.post(`api/${ApiVersion.V1}/wanted-persons`, wantedPerson);
  },
  getWantedPerson: (id: string): Promise<AxiosResponse<IWantedPerson>> => {
    return http.get(`api/${ApiVersion.V1}/wanted-persons/${id}`);
  },
  updateWantedPerson: (
    id: string,
    wantedPerson: IWantedPerson,
  ): Promise<AxiosResponse<IWantedPerson>> => {
    return http.put(`api/${ApiVersion.V1}/wanted-persons/${id}`, wantedPerson);
  },
  deleteWantedPerson: (id: string): Promise<AxiosResponse<void>> => {
    return http.delete(`api/${ApiVersion.V1}/wanted-persons/${id}`);
  },
  getLinkedNarratives: (id: string) => {
    return http.get(`api/${ApiVersion.V1}/wanted-persons/${id}/narratives`);
  },
  saveNarrative: async (
    id: string,
    data: INarrativeRequest,
  ): Promise<AxiosResponse<INarrative>> => {
    return data._id
      ? WantedPersonApi.updateNarrative(id, data._id, data)
      : http.post(`api/${ApiVersion.V1}/wanted-persons/${id}/narratives`, data);
  },
  updateNarrative: (
    id: string,
    narrativeId: string,
    data: INarrativeRequest,
  ): Promise<AxiosResponse<INarrative>> => {
    return http.put(
      `api/${ApiVersion.V1}/wanted-persons/${id}/narratives/${narrativeId}`,
      data,
    );
  },
  deleteNarrative: (id: string, narrativeId: string) => {
    return http.delete(
      `api/${ApiVersion.V1}/wanted-persons/${id}/narratives/${narrativeId}`,
    );
  },
};
